import { Card } from "react-bootstrap";
import logoIcon from "../../Assets/images/Logos/logoOrange.png";

import "./styles.css";

export function Layout({
  children,
  marginTop = "80px",
  cardStyle,
  className,
  hasCamera = false,
}) {
  return (
    <div className="page_container">
      <div className="logo_container">
        <img src={logoIcon} alt="Logotipo" />
      </div>

      <div style={{ marginTop }}>
        <Card
          className={`card_container ${hasCamera ? "camera_card" : "px-4 py-5"} ${className ? className : ""} `}
          style={cardStyle}
        >
          {children}
        </Card>
      </div>
    </div>
  );
}
